module.exports = __webpack_public_path__ + "fonts/pt_serif-web-regular-webfont.woff";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/PT_Serif/pt_serif-web-regular-webfont.woff
// module id = 3450
// module chunks = 0